import omit from 'lodash/omit';

export default function derefMapboxStyle(style: mapboxgl.Style) {
    return {
        ...style,
        layers: style.layers!.map(layer => {

            const refLayer = layer.ref ?
                style.layers!.find(_layer => _layer.id === layer.ref) :
                null;

            return {
                ...omit(refLayer, 'interactive'),
                ...omit(layer, 'ref', 'interactive')
            };
        })
    };
}
